/** Querysleutels per plek: de sleutels van het bedrijf en die van het platform staan los. */
export const integrationKeys = {
    list: (owner: 'company' | 'platform') => ['api-keys', owner] as const,
    activity: (owner: 'company' | 'platform', uuid: string) =>
        ['api-keys', owner, uuid, 'activity'] as const,
};
